import { SurfaceIdentitySurface } from "@redotech/crdb-enums/surface-identity/surface-identity-surface";
import * as z from "zod";

export const verifySurfaceIdentity = {
  name: "verifySurfaceIdentity" as const,
  input: z.object({
    token: z.string().min(1),
    confirmedLink: z.boolean().optional(),
  }),
  // `ok` is not a unique discriminator: confirm and terminal failures both
  // return ok=false. A union keeps those shapes distinct without colliding.
  output: z.union([
    z.object({
      ok: z.literal(true),
      surface: z.enum(SurfaceIdentitySurface),
      surfaceKey: z.string(),
      /** A spent link whose address the signed-in user already holds. */
      alreadyConnected: z.boolean().optional(),
      /** The sign-in resumed an email whose answer may land in a chat; poll getAskRedoEmailSignInChat with it. */
      emailChatResumeId: z.string().optional(),
    }),
    z.object({
      ok: z.literal(false),
      reason: z.literal("confirm_address_link"),
      claimedAddress: z.string(),
    }),
    z.object({
      ok: z.literal(false),
      reason: z.literal("confirm_surface_link"),
      surface: z.enum(SurfaceIdentitySurface),
      surfaceKey: z.string(),
    }),
    z.object({
      ok: z.literal(false),
      reason: z.literal("expired"),
      /** A mailed email link can ask for a replacement. */
      canRequestNewLink: z.boolean(),
    }),
    z.object({
      ok: z.literal(false),
      reason: z.enum(["invalid", "already_used"]),
    }),
  ]),
};
